<script>
import { mapState } from 'vuex';

export default {
    name: "Header",
    data() {
        return {
            isShowMenu: false,
        };
    },
    computed: {
        ...mapState(['nav', 'isLogin', 'userinfo']),
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route.path': function(){
            this.isShowMenu = false;
        },
    },
    methods: {},
};
</script>

<template>
    <div class="header">
        <div class="wrapper layout_main flex justify_end">
            <router-link class="logo" to="/"></router-link>
            <div class="menu_switch" @click="isShowMenu = true"><span></span><span></span><span></span></div>
            <div class="menu flex align_center" :class="{show: isShowMenu}">
                <div class="btn_close" @click="isShowMenu = false"></div>
                <router-link class="item flex flex_column" v-for="(item, index) in nav" :key="index" :to="item.link" :text="item.name">{{ item.name }}</router-link>
                <!-- login -->
                <router-link class="item flex flex_column" v-if="!isLogin" to="/login" text="Student Login">Student Login</router-link>
                <router-link class="item flex flex_column" v-else to="/mine">{{ userinfo.email }}</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.header{
    background: var(--background-color);
    position: relative;
    z-index: 99;
    .wrapper{
        height: 1rem;
        position: relative;
        @media only screen and (max-width: 750px) {
            height: .9rem;
        }
    }
    .logo{
        position: absolute;
        top: 0;
        left: 0;
        width: 1.4rem;
        height: 1.19rem;
        background: url('~@/assets/images/logo.png') no-repeat 0/100%;
        @media only screen and (max-width: 750px) {
            width: 1.24rem;
            height: 1.08rem;
        }
    }
    .menu_switch{
        display: none;
        flex-direction: column;
        justify-content: center;
        gap: .1rem;
        span{
            width: .4rem;
            height: .04rem;
            background: #fff;
            border-radius: .04rem;
        }
        @media only screen and (max-width: 750px) {
            display: flex;
        }
    }
    .menu{
        gap: .35rem;
        @media only screen and (max-width: 750px) {
            gap: .2rem;
            width: 4.4rem;
            height: 100%;
            background: #fff;
            position: fixed;
            top: 0;
            right: 0;
            z-index: 999;
            flex-direction: column;
            align-items: end;
            opacity: 0;
            transform: translate(100%, 0);
            transition: transform .3s, opacity .3s;
            &.show{
                opacity: 1;
                transform: translate(0, 0);
            }
        }
        .btn_close{
            display: none;
            width: .9rem;
            height: .9rem;
            margin-bottom: .5rem;
            position: relative;
            &::before,
            &::after{
                content: "";
                width: .5rem;
                height: .04rem;
                background: #000;
                border-radius: .04rem;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
            @media only screen and (max-width: 750px) {
                display: block;
            }
        }
        .username,
        .item{
            height: .3rem;
            padding: 0 .15rem;
            font-size: .18rem;
            color: #fff;
            position: relative;
            line-height: 2;
            text-align: center;
            margin-top: .3rem;
            @media only screen and (max-width: 750px) {
                color: #666;
                width: 100%;
                margin: 0;
                text-align: right;
                padding: 0 .3rem;
                font-size: .28rem;
                height: auto;
                line-height: .5rem;
            }
        }
        .username{
            text-decoration: underline;
        }
        .item{
            &::before{
                content: "";
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                border: 1px solid var(--color-blue);
                border-radius: .3rem;
                display: none;
            }
            &::after{
                display: block;
                content: attr(text);
                font-weight: bold;
                visibility: hidden;
                height: 1px;
                color: transparent;
                margin-bottom: -1px;
                overflow: hidden;
                @media only screen and (max-width: 750px) {
                    display: none;
                }
            }
            &.active,
            &:hover{
                &::before{
                    display: block;
                    @media only screen and (max-width: 750px) {
                        display: none;
                    }
                }
                color: var(--color-blue);
                font-weight: bold;
            }
        }
    }
}
</style>